export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '优惠券领取记录';
